<div class="modal-header">
    <h4 class="modal-title fw-semibold fs-5">
        Cancel Booking
    </h4>
</div>
<div class="modal-body">
    <div class="vstack gap-2">
        <span class="text-muted">
            Are you sure you want to cancel your booking?
            If you change your mind, you will have to book again.
        </span>
        @if (orderedCancellationReasons.length > 0) {
            <div class="form-group">
                <label for="cancellationReason" class="form-label">Reason for cancellation (optional)</label>
                <select
                    id="cancellationReason"
                    class="form-select"
                    [(ngModel)]="selectedCancellationReason"
                    data-testid="cancellation-reason"
                >
                    <option [ngValue]="null">No reason</option>
                    @for (reason of orderedCancellationReasons; track reason.id) {
                        <option [ngValue]="reason">{{ reason.displayName }}</option>
                    }
                </select>
            </div>
        }
        @if (bookingDetails.sale) {
            <section class="border rounded-3 p-3 vstack gap-3" aria-label="Cancellation payment summary" data-testid="cancellation-payment-summary">
                <h5 class="mb-0">Payment details</h5>
                @if (bookingDetails.depositAmountPaid) {
                    <div class="d-flex justify-content-between"><span>Deposit refund</span><strong>{{ null | currencyUnit:bookingDetails.depositRefundAmount:bookingDetails.currencyCode }}</strong></div>
                }
                @for (line of bookingDetails.sale.order.lineItems; track line.id) {
                    <div class="d-flex justify-content-between gap-3">
                        <span>{{ line.quantity }} × {{ line.name }}@if (line.paidOnline) { <small class="d-block text-secondary">
                            @if (bookingDetails.hasUnpaidOrder) { Not paid · Nothing to refund }
                            @else if (bookingDetails.sale.isLineRefunded(line.id)) { Already refunded }
                            @else if (bookingDetails.orderLineWillBeRefunded(line.id)) { Will be refunded }
                            @else { Not refunded }
                        </small> }</span>
                        @if (line.paidOnline) { <span>{{ null | currencyUnit:bookingDetails.sale.remainingLineAmount(line.id):bookingDetails.currencyCode }}</span> }
                    </div>
                }
                <div class="d-flex justify-content-between border-top pt-3 fw-semibold"><span>Total refund</span><span>{{ null | currencyUnit:bookingDetails.cancellationRefundAmount:bookingDetails.currencyCode }}</span></div>
                <div class="d-flex justify-content-between"><span>Amount not refunded</span><span>{{ null | currencyUnit:bookingDetails.retainedPaymentAmount:bookingDetails.currencyCode }}</span></div>
                @if (bookingDetails.cancellationChargeAmount && !bookingDetails.cancellationChargeAutomatically) {
                    <p class="small mb-0">The venue may separately charge a late cancellation fee of {{ null | currencyUnit:bookingDetails.cancellationChargeAmount:bookingDetails.currencyCode }} under your booking policy.</p>
                }
                @if (bookingDetails.cancellationFeeDue > 0) {
                    <div class="d-flex justify-content-between text-danger"><span>Cancellation fee</span><strong>{{ null | currencyUnit:bookingDetails.cancellationFeeDue:bookingDetails.currencyCode }}</strong></div>
                }
            </section>
        }
        @if (bookingDetails.cancellationCharge !== null && !bookingDetails.sale) {
            <p>
                If you cancel this booking after
                <span class="fw-semibold">
                    {{ bookingDetails.cancellationChargeCutOffTime | date:'shortTime' }}
                </span>
                on
                <span class="fw-semibold">
                    {{ bookingDetails.cancellationChargeCutOffTime | date:'fullDate' }}</span>,
                    you {{ bookingDetails.cancellationChargeAutomatically ? 'will' : 'may' }} be charged a cancellation fee of
                <span class="fw-semibold">
                    {{ bookingDetails.cancellationCharge | currencyUnit }}</span>.
            </p>
        }
    </div>
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-outline-secondary"
        autofocus
        (click)="cancelSelected.emit()"
    >
        No, Go Back
    </button>
    <button
        type="button"
        class="btn btn-danger"
        (click)="onConfirm()"
    >
        Yes, Cancel My Booking
    </button>
</div>
